import React from 'react';
import ImagePath from 'app/utilities/imagePath';
import { useSelector } from 'react-redux';
import { RootState } from 'app/redux/store';
import rupiahCurrencyFormatter from 'app/utils/RupiahPipe';
import TextLabel from '../TextLabel/TextLabel';
import './InformationCard.scss';

export interface InfoCardTextLabel {
	logo?: {src: string, alt: string},
	title: string,
	value: string
}
export interface TextLabelCard {
	data: InfoCardTextLabel[],
	loading: boolean
}

const InformationCard = function init(props: TextLabelCard): React.ReactElement {
	const { data, loading } = props;
	const portofolioState = useSelector((state: RootState) => state.portofolioReducer);
	const { lenderSummary } = portofolioState;

	return (
		<>
		<div className="cash-balance">
			<div className="header">
				<img src={ImagePath.wallet.src} alt={ImagePath.wallet.alt} />
				Cash Balance
			</div>
			<div className="d-flex">
				{
					lenderSummary.additionalCashBalance !== null && (
						<>
							<div className="content">
								<div>
									<img src={ImagePath.bankBni.src} alt={ImagePath.bankBni.alt} />
								</div>
								<div className="amount">{rupiahCurrencyFormatter(lenderSummary.additionalCashBalance)}</div>
							</div>
							<div className="vertical-line" />
						</>
					)
				}
				<div className="content">
					<div>
						<img src={ImagePath.bankBsim.src} alt={ImagePath.bankBsim.alt} />
					</div>
					<div className="amount">{rupiahCurrencyFormatter(lenderSummary.cashBalance)}</div>
				</div>
			</div>
		</div>

		<div className="d-flex">
			{
				data && data.map((each: InfoCardTextLabel) => (
					<div className="card-amount" key={each.title}>
						<img src={each.logo?.src} alt={each.logo?.alt} />
						<TextLabel
								bg
								title={each.title}
								value={each.value}
								key={each.title}
								loading={loading}
						/>
					</div>
				))
			}
		</div>
		</>
	);
};

export default InformationCard;
